<template lang="pug">
.simple-item.finger(@click="$emit('click')")
  img.icon(src="@/assets/home/icon-simple.svg")
  .tag(v-if="itemData.tag") {{ itemData.tag }}
  .title(:title="itemData.title") {{ itemData.title }}
  .extend {{ itemData.extend }}
</template>

<script>
export default {
  name: "SimpleItem",
  props: {
    itemData: Object,
  }
}
</script>

<style lang="scss" scoped>
.simple-item{
  display: flex;
  align-items: center;
  padding: 10px 0;
  &:hover{

  }
  .icon{
    @include square(16px);
    margin-right: 8px;
  }
  .tag{
    font-size: 16px;
    color: #FF5C00;
    border-right: 1px solid rgba(0, 0, 0, 0.1);
    padding-right: 8px;
    margin-right: 8px;
  }
  .title{
    flex: 1;
    font-size: 16px;
    color: #202948;
    @include textOverflow();
  }
  .extend{
    font-size: 12px;
    color: rgba(0, 0, 0, 0.4);
    white-space: nowrap;
    padding-left: 16px;
  }
}
</style>
